/* tslint:disable */
/* eslint-disable */

/**
 * Which row of a merge pair a pick group's values come from.
 */
export enum MergePickSide {
  Source = 'source',
  Destination = 'destination'
}
